export const STATUS_DISPARO_PAUSADO = 'Pausado';

export const STATUS_DISPARO_PAUSAVEL = ['Em fila', 'Processando', 'Aguardando Envio', 'Agendado'];

export const TIPO_DISPARO_PAUSAVEL = 'Whatsapp';

export const COR_BOTAO_PAUSAR_DISPARO = '#84063d';

export const TEXTO_CONFIRMACAO_PAUSAR_DISPARO = 'Deseja pausar o envio deste disparo? Ele só volta a enviar quando for despausado.';

export const MENSAGEM_DISPARO_PAUSADO = 'Disparo pausado!';

export const MENSAGEM_DISPARO_DESPAUSADO = 'Disparo despausado! O envio será retomado em instantes.';
